<template>
  <div class="w-100">
    <div class="header d-flex align-items-center w-100 justify-content-between">
      <p class="header-title mb-0">Other Expenses</p>
      <p class="header-title mb-0">
        {{ NumberFormatter(totalExpenditure.indrct_expns_other_expenses) }}
      </p>
    </div>
    <form
      :id="item.model"
      @submit="handleSubmit"
      v-for="(item, index) in data"
      :key="item.id"
      :class="`w-100 table-body ${!index || !(index % 2) ? 'white' : 'gray'} ${
        item?.sub ? 'sub' : ''
      } d-flex align-items-center justify-content-between`"
    >
      <p class="mb-0 body-title">{{ item.name }}</p>
      <p
        v-if="!item.showInput"
        class="body-title mb-0"
        @click="openCloseInput(item.model, true)"
      >
        {{ NumberFormatter(indirect_expenses[item.model]) }}
      </p>
      <input
        :id="'input-' + item.model"
        :hidden="!item.showInput"
        v-model="indirect_expenses[item.model]"
        type="number"
        class="clickable-text"
        @blur="openCloseInput(item.model, false)"
      />
    </form>
    <div
      class="table-body d-flex align-items-center w-100 justify-content-between"
    >
      <p class="sub-title mb-0">Other Income</p>
    </div>
  </div>
</template>

<script setup>
import { generate } from "randomized-string";
import { ref, watch } from "vue";
import { useExpenditureStore } from "../../../../../store/expenditure";
import NumberSeparator from "number-separator";
import { storeToRefs } from "pinia";
import { NumberFormatter } from "../../../../../helpers/numberFormatter";
import { useRoute } from "vue-router";

const props = defineProps({
  view: {
    type: Boolean,
    default: false
  }
});
const route = useRoute();
const data = ref([
  {
    model: "indrct_expns_other_expenses_hotel_boarding_and_loadging",
    name: "1. Hotel Boarding and Lodging",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_tours_and_travel_domestic",
    name: "2. Tours and Travels (Domestic)",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_tours_and_travel_intrntnl",
    name: "3. Tours and Travels (Foreign)",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_conveyance_expenses",
    name: "4. Conveyance Expenses",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_guest_house_expenses",
    name: "5. Guest House Expenses",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_festival_expenses",
    name: "6. Festival Expenses",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_scholarship",
    name: "7. Scholarship",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_donations",
    name: "8. Donation",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_royalty_expenses",
    name: "9. Royalty Expenses",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_bad_debts",
    name: "10. Bad Debts",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_misscellaneouse_expenses",
    name: "11. Miscellaneous Expenses",
    sub: false,
    amount: "0000.00"
  },
  {
    model: "indrct_expns_other_expenses_others_expenses",
    name: "12. Other Expenses",
    sub: false,
    amount: "0000.00"
  }
]);
const openCloseInput = async (model, value) => {
  if (props.view || route.query.business === "master") {
    return;
  }
  const newValues = data.value.map((item) => {
    if (item.model === model) {
      return { ...item, showInput: value };
    }
    return item;
  });
  data.value = newValues;
  if (value) {
    const input = await document.getElementById(`input-${model}`);
    input.focus();
  }
};
const expenditureStore = useExpenditureStore();
const { indirect_expenses, totalExpenditure } = storeToRefs(expenditureStore);
totalExpenditure.value.indrct_expns_other_expenses = data.value.reduce(
  (a, b) => a + Number(indirect_expenses.value[b.model]),
  0
);

watch(
  indirect_expenses,
  (newValue) => {
    totalExpenditure.value.indrct_expns_other_expenses = data.value.reduce(
      (a, b) => a + Number(newValue[b.model]),
      0
    );
  },
  { deep: true }
);
const handleSubmit = async (e) => {
  e.preventDefault();
  let current_model = e.target.id;
  let next_model =
    data.value[data.value.map((e) => e.model).indexOf(current_model) + 1];
  // close current  input
  openCloseInput(current_model, false);
  if (next_model) {
    await openCloseInput(next_model.model, true);
  }
};
</script>

<style scoped>
.header {
  height: 44px;
  background: #0f75bc;
  padding-right: 100px;
  padding-left: 10px;
}

.header-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.055em;
  color: #fafbff;
}

.table-body {
  height: 44px;
  padding-right: 100px;
  padding-left: 26px;
}

.body-title {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.055em;
  color: #382628;
}

.white {
  background: #fafbff;
}

.gray {
  background: #deeded;
}

.table-body.sub {
  padding-left: 46px;
}

.sub-title {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.055em;
  color: #000000;
}

.total-container {
  min-height: 76px;
  border-top: 1px solid #747171;
  background: #fafbff;
  padding-right: 100px;
  padding-left: 10px;
}

.total-amount {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  color: #000000;
}
</style>
